// FAMILY-EXT: при изменении URL внутри Planka (внутри iframe-зонтика)
// шлём postMessage родителю с текущим путём. Umbrella сохраняет его в
// localStorage и при следующем монтировании iframe откроет ту же доску.
//
// Безопасность: targetOrigin '*' — приёмник (umbrella) проверит
// event.origin сам. Без iframe-режима (открыто отдельной вкладкой) —
// noop (window.parent === window).

import { takeEvery } from 'redux-saga/effects';
import { LOCATION_CHANGE_HANDLE } from '../../../lib/redux-router';

function* postRouteToParent() {
  if (typeof window === 'undefined') return;
  if (!window.parent || window.parent === window) return;
  const path = window.location.pathname + window.location.search + window.location.hash;
  try {
    window.parent.postMessage({ type: 'family-iframe-route', path }, '*');
  } catch (e) {
    // ignore — родитель может быть из другого origin без разрешений
  }
}

export default function* familyIframeRouteWatchers() {
  yield takeEvery(LOCATION_CHANGE_HANDLE, postRouteToParent);
}
